/**
 * связка устройств
 */

import { api } from 'services/api';
import {
  GetBundleForDeviceParams,
  GetBundleForMainDeviceResponse,
  GetBundleForSecondaryDeviceResponse,
  RemoveBundleForDeviceParams,
  SetBundleForDeviceParams,
  UpdateBundleDeviceLabelParams
} from 'types/bundleDevices';

const bundleDevicesApi = api
  .enhanceEndpoints({
    addTagTypes: ['bundleDevices', 'Device']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getBundleForDevice: build.query<
        GetBundleForSecondaryDeviceResponse | GetBundleForMainDeviceResponse,
        GetBundleForDeviceParams
      >({
        query: ({ mainDeviceId, ...params }) => ({
          url: `/device/${mainDeviceId}/bundle`,
          method: 'GET',
          params: {
            ...params
          }
        }),
        keepUnusedDataFor: 0,
        providesTags: (response, error, params) => [
          { type: 'bundleDevices', id: params.mainDeviceId }
        ]
      }),
      // установка новой связи аппаратов
      setBundleForDevice: build.mutation<void, SetBundleForDeviceParams>({
        query: ({ mainDeviceId, secondaryDeviceId }) => ({
          url: `/device/${mainDeviceId}/bundle/${secondaryDeviceId}`,
          method: 'POST'
        }),
        invalidatesTags: ['bundleDevices']
      }),
      // удаление связи аппаратов
      removeBundleForDevice: build.mutation<void, RemoveBundleForDeviceParams>({
        query: ({ mainDeviceId, secondaryDeviceId }) => ({
          url: `/device/${mainDeviceId}/bundle/${secondaryDeviceId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['bundleDevices']
      }),
      // обновление только лейбла
      updateBundleDeviceLabel: build.mutation<
        void,
        UpdateBundleDeviceLabelParams
      >({
        query: ({ deviceId, deviceLabel }) => ({
          url: `/device/${deviceId}/bundle?deviceLabel=${deviceLabel}`,
          method: 'POST'
        }),
        invalidatesTags: (_res, _err, params) => [
          { type: 'Device', id: params.deviceId }
        ]
      })
    })
  });

export const {
  useGetBundleForDeviceQuery,
  useSetBundleForDeviceMutation,
  useRemoveBundleForDeviceMutation,
  useUpdateBundleDeviceLabelMutation
} = bundleDevicesApi;
